import { render, staticRenderFns } from "./BranchProductReportViewer.vue?vue&type=template&id=6b47014e"
import script from "./BranchProductReportViewer.vue?vue&type=script&lang=js"
export * from "./BranchProductReportViewer.vue?vue&type=script&lang=js"
import style0 from "./BranchProductReportViewer.vue?vue&type=style&index=0&id=6b47014e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports